import type { FC } from "react";

import { Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { LOBTooltip } from "app/components/React/Tooltip/LOBTooltip/LOBTooltip";
import { ComparisonMode } from "app/UtilitiesAndConstants/Constants/Moment";

import { getYoYChangeTooltip } from "../../../helpers";

import { LabelRow, StyledItemIcon, Dot } from "./styledComponents";
import ChangeIndicator from "../../../shared/ChangeIndicator/ChangeIndicator";

const LabelItemWithDot: FC<{ children: React.ReactNode }> = ({ children }) => (
    <>
        <Dot>•</Dot>
        {children}
    </>
);
export const SharedLabelRow: FC<{
    label: string;
    value: string | number;
    favicon?: string;
    percentage?: string;
    yoyChange?: number;
    className?: string;
    isHoverable?: boolean;
}> = ({ label, value, favicon, percentage, yoyChange, className, isHoverable = true }) => {
    const tooltipContent = getYoYChangeTooltip();
    return (
        <LabelRow className={className}>
            {favicon ? <StyledItemIcon iconSrc={favicon} /> : null}
            {isHoverable ? (
                <LOBTooltip
                    domain={label}
                    placement="top-left"
                >
                    <Text fontVariant="input2">{label}</Text>
                </LOBTooltip>
            ) : (
                <Text fontVariant="input2">{label}</Text>
            )}
            <LabelItemWithDot>
                <Text fontVariant="input2Bold">{value}</Text>
            </LabelItemWithDot>
            {percentage ? (
                <LabelItemWithDot>
                    <Text fontVariant="input2">{percentage}</Text>
                </LabelItemWithDot>
            ) : null}
            {yoyChange && yoyChange !== null ? (
                <LabelItemWithDot>
                    <Tooltip content={tooltipContent}>
                        <span>
                            <ChangeIndicator
                                granularity={ComparisonMode.YOY}
                                change={yoyChange}
                            />
                        </span>
                    </Tooltip>
                </LabelItemWithDot>
            ) : null}
        </LabelRow>
    );
};
